'use client';
import MainSection from './_bs/MainSection';
import MeetingIntroSection from './_bs/MeetingIntroSection';
import MeetingGuestSection from './_bs/MeetingGuestSection';
import MeetingMessageSection from './_bs/MeetingMessageSection';
import MeetingAgendaSection from './_bs/MeetingAgendaSection';
import MeetingExhibitionAreaSection from './_bs/MeetingExhibitionAreaSection';
import MeetingReviewSection, {
  MeetingReviewImageSection,
} from './_bs/MeetingReviewSection';
import MeetingCooperateSection from './_bs/MeetingCooperateSection';
import LanguageSwitcher from './component/LanguageSwitcher';
import { useLocale } from 'use-intl';
import { CMSData, MeetingModule, MeetingStatus } from './type';
import { getCMSIntlVal } from './utils/common';

import './styles/common.css';
import { useMedia } from '@ssv-website/hooks';
import { MeetingConfigProvider } from './context/MeetingConfigContext';
import AiForGoodSection from './_bs/AiForGoodSection';
import { Share } from '../components/Share';
import SSVFooter from '../components/SSVFooter/index';
import { Navbar } from '../../navbar';
import SSVNavbar from '../components/SSVNavbar';
import MeetingVideoReviewSection from './_bs/MeetingVideoReviewSection';
import MeetingAgendaReviewSection from './_bs/MeetingAgendaReviewSection';
import MeetingDownReportSection from './_bs/MeetingDownReportSection';

type ModuleComponentMap = {
  [K in MeetingModule]?: React.FC<any>;
};

export default function SSVMeeting2025({
  data,
  isExternalDomain = false,
}: {
  data: CMSData;
  /** 是否外网服务 */
  isExternalDomain?: boolean;
}) {
  const { pageModuleData = [] } = data || {};
  // console.log(data, 'data');
  const locale = useLocale();
  const isMobile = useMedia('mobile');
  const mettingMainConfig = data.meetingMainConfig?.[0] || {};
  // mettingMainConfig.status = MeetingStatus.Review;
  const { status } = mettingMainConfig || {};
  // 追加本地直播地址
  mettingMainConfig.liveUrl =
    process.env.NEXT_PUBLIC_APP_SERVER_URL + '/s-live';

  const moduleComponentMap: ModuleComponentMap = {
    // 大会介绍
    [MeetingModule.MeetingIntroModule]: MeetingIntroSection,
    // 与会嘉宾
    [MeetingModule.GuestModule]: MeetingGuestSection,
    // 会议议程
    [MeetingModule.AgendaModule]: MeetingAgendaSection,
    // 会议展区
    [MeetingModule.ExhibitionAreaModule]: MeetingExhibitionAreaSection,
    // 会议资讯
    [MeetingModule.MessageModule]: MeetingMessageSection,
    // 会议回顾
    [MeetingModule.ReviewModule]: MeetingReviewSection,
    // 合作伙伴
    [MeetingModule.CooperateModule]: MeetingCooperateSection,
    // ai向善
    [MeetingModule.AiForGoodModule]: AiForGoodSection,
    // 精彩视频回顾
    [MeetingModule.VideoReviewModule]: MeetingVideoReviewSection,
    // 议程回顾
    [MeetingModule.AgendaReviewModule]: MeetingAgendaReviewSection,
    // 精彩图片回顾
    [MeetingModule.ReviewImageModule]: MeetingReviewImageSection,
    // 下载报告
    [MeetingModule.ReportResourceModule]: MeetingDownReportSection,
  };

  return (
    <MeetingConfigProvider
      mainConfig={mettingMainConfig}
      isExternalDomain={isExternalDomain}
    >
      <div className="min-w-[1600px] mobile:min-w-full bg-[#EDF3FF] flex flex-col">
        {/* 导航 */}
        {isExternalDomain ? <SSVNavbar /> : <Navbar />}
        {/* 分享 */}
        <Share />
        {/* 内容 */}
        <div
          className={`w-full pb-[160px] relative mobile:pb-[50px] ${
            isMobile === true ? 'main-kv-bg-m' : ''
          } ${isMobile === false ? 'main-kv-bg' : ''}`}
          style={{
            fontFamily: 'Microsoft YaHei',
          }}
        >
          {/* 语言切换 */}
          <div className="absolute min-w-[1372px] left-1/2 -translate-x-1/2 top-[70px] text-right z-10 mobile:min-w-full mobile:top-[120px]">
            <LanguageSwitcher className="mobile:mr-5"></LanguageSwitcher>
          </div>
          {/* 主要内容 */}
          <MainSection></MainSection>
          {pageModuleData.map((item) => {
            // 隐藏模块
            if (Number(item.hidden)) return null;

            // 检查权限
            const ruleList = item.rules?.split(',') || [];
            if (ruleList.length > 0 && !ruleList.includes(status)) return null;

            // 检查渲染模块
            const ModuleComponent = moduleComponentMap[item.moduleName];
            if (!ModuleComponent) return null;

            // 检查模块数据是否存在
            const moduleData = data[item.moduleDataKey];
            if (!moduleData) return null;

            const title = getCMSIntlVal(item, 'title', locale);
            const props = {
              data: moduleData,
              title,
            };
            return <ModuleComponent key={item.id} {...props} />;
          })}
        </div>
        {/* 底部 */}
        <SSVFooter
          className={`${
            [MeetingStatus.NotStarted, MeetingStatus.InProgress].includes(
              status
            )
              ? 'mb-[116px] mobile:mb-[65px]'
              : ''
          }`}
        />
      </div>
    </MeetingConfigProvider>
  );
}
